import React from "react";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

export default function Whenfin() {
  return (
    <div className="max-w-2xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-2 flex justify-between items-center gap-2">
        Whenfin
      </h1>
      <div className="mb-2 flex items-center space-x-2 text-indigo-500 font-medium text-sm">
        <a
          href="https://whenfin.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1"
        >
          Website <ArrowTopRightOnSquareIcon className="w-4 h-4 inline" />
        </a>
        <span className="text-gray-300">|</span>
        <a
          href="https://whenfin.com/documentation"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1"
        >
          Documentation <ArrowTopRightOnSquareIcon className="w-4 h-4 inline" />
        </a>
        <span className="text-gray-300">|</span>
        <a
          href="https://apps.apple.com/us/app/whenfin/id6504001973"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1"
        >
          iOS App Store <ArrowTopRightOnSquareIcon className="w-4 h-4 inline" />
        </a>
      </div>
      <div className="mb-2 text-gray-700">
        Whenfin is a full-stack project that allows developers to send push
        notifications directly from their code.
      </div>
      <span className="inline-flex flex-wrap gap-1 mb-8">
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-200">
          JavaScript
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-200">
          Python
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200 ml-2">
          React.js
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          Infrastructure
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          Mobile App
        </span>
        <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          API Design
        </span>
      </span>
      <div className="mb-6">
        <h2 className="font-semibold text-base mb-1">Components</h2>
        <ul className="list-disc ml-6 text-gray-700">
          <li>Python client library</li>
          <li>Express.js backend API</li>
          <li>iOS mobile app (React Native)</li>
          <li>React-based documentation site</li>
        </ul>
      </div>
      <div className="mb-6">
        <h2 className="font-semibold text-base mb-1">Features</h2>
        <ul className="list-disc ml-6 text-gray-700">
          <li>Send notifications from any Python script</li>
          <li>
            Easy setup:{" "}
            <code className="bg-gray-100 px-1 rounded">
              pip install whenfin
            </code>
          </li>
          <li>Project-based notification inboxes</li>
          <li>API access for advanced integrations (e.g. outside of Python)</li>
          <li>Secure authentication and device management</li>
        </ul>
      </div>
      <div>
        <h2 className="font-semibold text-base mb-1">Quick Start</h2>
        <p>
          The documentation page walks through how to set up the app locally.
          Then, just run:
        </p>
        <pre className="bg-gray-100 rounded p-3 text-sm overflow-x-auto mb-2">
          {`pip install whenfin

from whenfin import Whenfin
Whenfin.connect("user", "project", "secret")
Whenfin.send("Success", "Training finished.")`}
        </pre>
      </div>
    </div>
  );
}
